import { useLocation, useNavigate } from "react-router-dom"
import { useEffect, useRef, useState } from "react";
import ShortUniqueId from "short-unique-id"
import { format } from 'date-and-time';
import "./css/exam.css"

const Exam = () => {
    const uid = new ShortUniqueId({ length: 8 })
    const location = useLocation()
    const url = process.env.REACT_APP_SERVER_URL
    const navigate = useNavigate()
    const elemRef = useRef(null);
    const paper = location.state?.paper || null;

    const timer = sessionStorage.getItem("timer")
    const langauge = sessionStorage.getItem("language")
    const year = sessionStorage.getItem("year")
    const type = sessionStorage.getItem("type")

    const splitlanguage = paper?.data?.language?.split("\n").sort() || []

    const [item, setItem] = useState(0)
    const [index, setIndex] = useState("00")
    const [question, setQuestion] = useState(null)
    const [optionOne, setOptionOne] = useState(null)
    const [optionTwo, setOptionTwo] = useState(null)
    const [optionThree, setOptionThree] = useState(null)
    const [optionFour, setOptionFour] = useState(null)
    const [answer, setAnswer] = useState(null) 

    const [changeLanguage, setChangeLanguage] = useState(langauge)
    const [indexColors, setIndexColors] = useState({}); 
    const [selectedAnswers, setSelectedAnswers] = useState({}); 
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0); 
    const [storedAnswers, setStoredAnswers] = useState({}); 
    const [examCode, setExamCode] = useState("")

    const [submitPopup, setSubmitPopup] = useState(false)
    const [startTest, setStartTest] = useState(true) 
    const [showinfobox, setShowinfobox] = useState(true)
    const [showIndex, setshowIndex] = useState(false)
    const [testClose, setTestClose] = useState(false)

    const [timeLeft, setTimeLeft] = useState(0);
    const [timerInterval, setTimerInterval] = useState(null);

    useEffect(() => {
        if (paper === null) {
            navigate('/test', { replace: true });
            return;
        }

        if (changeLanguage === splitlanguage[0]) {
            setChangeLanguage(splitlanguage[1])
        } else {
            setChangeLanguage(splitlanguage[0])
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paper, navigate])

    const closeText = async () => {
        if (document.exitFullscreen) {
            await document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }

        const data = {
            userTestId: sessionStorage.getItem("userTestId"),
            testcode: paper?.data?.testcode || "",
        }

        try {
            const Response = await fetch(`${url}/api/clearexam`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify(data),
            })

            const result = await Response.json()
            if (result.status === true) {
                navigate("/test")
            } else {
                alert("Something went wrong, please try again")
            }
        } catch (error) {
            console.error("Close Error:", error);
            alert("Network error.");
        }
    }

    useEffect(() => {
        if (paper && paper.questionOne) {
            const initialColors = {};
            for (let i = 0; i < paper.questionOne.length; i++) {
                initialColors[i] = "black";
            }
            setIndexColors(initialColors);
            updateIndexColor(0, "blue");
            updateQuestion(0);
        }

        if (year !== "undefined") {
            setExamCode(year);
        }
        if (paper?.data?.seriescode !== undefined) {
            setExamCode(`${paper?.data?.seriescode} / ${paper?.data?.seriesno}`);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paper, year]);

    useEffect(() => {
        return () => {
            if (timerInterval) {
                clearInterval(timerInterval);
            }
        };
    }, [timerInterval]);

    const updateIndexColor = (index, color) => {
        setIndexColors((prevColors) => ({
            ...prevColors,
            [index]: color
        }));
    };

    // FIX: अब यह फंक्शन तभी कलर पीला (Yellow) करेगा जब हम इस क्वेश्चन को छोड़कर जाएँगे
    const setColorForLeavingQuestion = (leavingIndex) => {
        const currentColor = indexColors[leavingIndex];
        // अगर क्वेश्चन हरा (Saved) या लाल (Review) नहीं है, तो उसे छोड़कर जाते वक्त पीला कर दो
        if (currentColor !== "#00A86B" && currentColor !== "#800000") {
            updateIndexColor(leavingIndex, "#F4C430");
        }
    };

    const setColorForEnteringQuestion = (enteringIndex) => {
        const targetColor = indexColors[enteringIndex];
        if (targetColor !== "#00A86B" && targetColor !== "#800000") {
            updateIndexColor(enteringIndex, "blue");
        }
    };

    const parseDuration = (duration) => {
        if (!duration) return 0;
        const [hours, minutes] = duration.split(':').map(Number);
        return (hours * 60) + minutes;
    };

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    const startTimer = () => {
        if (!paper?.data?.duration) return;

        const totalMinutes = parseDuration(paper?.data?.duration || 0);
        const totalSeconds = totalMinutes * 60;
        setTimeLeft(totalSeconds);

        if (timerInterval) {
            clearInterval(timerInterval);
        }

        const interval = setInterval(() => {
            setTimeLeft(prevTime => {
                if (prevTime <= 1) {
                    clearInterval(interval);
                    handleAutoSubmit();
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);

        setTimerInterval(interval);
    };

    const handleAutoSubmit = async () => {
        if (timerInterval) clearInterval(timerInterval);
        await submit();
        alert("Time's up! Your test has been submitted automatically.");
    };

    const BackToTest = () => {
        if (timerInterval) clearInterval(timerInterval);
        navigate("/test")
    }

    const testRun = () => {
        setStartTest(!startTest)
        const elem = elemRef.current;
        const openFullscreen = () => {
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.webkitRequestFullscreen) {
                elem.webkitRequestFullscreen(); 
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen(); 
            }
        };
        openFullscreen();

        sessionStorage.setItem("userTestId", uid())
        sessionStorage.setItem("date", format(new Date(), 'DD MM YYYY'))
        sessionStorage.setItem("time", format(new Date(), 'hh:mm:ss A'))

        if (timer === "on") startTimer();
    }

    const indexClick = (item) => {
        setColorForLeavingQuestion(currentQuestionIndex);
        setColorForEnteringQuestion(item);
        updateQuestion(item)
        setCurrentQuestionIndex(item);
    }

    const QuestionOne = (item) => {
        setQuestion(paper.questionOne[item].questionOne)
        setOptionOne(paper.questionOne[item].questionOneOptionOne)
        setOptionTwo(paper.questionOne[item].questionOneOptionTwo)
        setOptionThree(paper.questionOne[item].questionOneOptionThree)
        setOptionFour(paper.questionOne[item].questionOneOptionFour)

        const questionId = paper.questionOne[item].questionId;
        const storedAnswer = storedAnswers[questionId];
        if (storedAnswer) {
            setAnswer(storedAnswer);
        } else {
            setAnswer(selectedAnswers[item] || null);
        }
    }

    const QuestionTwo = (item) => {
        setQuestion(paper.questionTwo[item].questionTwo)
        setOptionOne(paper.questionTwo[item].questionTwoOptionOne)
        setOptionTwo(paper.questionTwo[item].questionTwoOptionTwo)
        setOptionThree(paper.questionTwo[item].questionTwoOptionThree)
        setOptionFour(paper.questionTwo[item].questionTwoOptionFour)

        const questionId = paper.questionTwo[item].questionId;
        const storedAnswer = storedAnswers[questionId];
        if (storedAnswer) {
            setAnswer(storedAnswer);
        } else {
            setAnswer(selectedAnswers[item] || null);
        }
    }

    const updateQuestion = (item) => {
        setItem(item)
        setIndex(String(item + 1).padStart(2, '0'))
        if (splitlanguage.length === 1) {
            QuestionOne(item)
        }

        if (splitlanguage.length === 2) {
            if ((paper.questionOne[item].languageOne || paper.questionOne[item - 2].languageOne) === langauge) {
                QuestionOne(item)
            } else {
                QuestionTwo(item)
            }
        }
    }

    const languageChange = () => {
        if (changeLanguage === splitlanguage[0]) {
            setChangeLanguage(splitlanguage[1])
            QuestionOne(item)
        } else {
            setChangeLanguage(splitlanguage[0])
            QuestionTwo(item)
        }
    }

    // FIX: जब हम आंसर क्लियर करें, तो क्वेश्चन स्क्रीन पर है, इसलिए वह ब्लू (Blue) ही रहना चाहिए
    const clear = () => {
        const radios = document.getElementsByName("Answer");
        radios.forEach(radio => (radio.checked = false));
        setAnswer(null);

        setSelectedAnswers(prev => {
            const newAnswers = { ...prev };
            delete newAnswers[item];
            return newAnswers;
        });

        // कलर को पीला मत करो, क्योंकि यूजर अभी भी इसी क्वेश्चन पर है
        updateIndexColor(item, "blue");
    }

    const previous = () => {
        if (item > 0) {
            setColorForLeavingQuestion(item);
            setIndex(String(item).padStart(2, '0'))
            updateQuestion(item - 1)
            setCurrentQuestionIndex(item - 1);
            setColorForEnteringQuestion(item - 1);
        }
    }

    const saveResult = async () => {
        if (item < paper.questionOne.length) {
            if (item < paper.questionOne.length - 1) {
                setIndex(String(item + 2).padStart(2, '0'))
                updateQuestion(item + 1)
            }

            const data = {
                answer: answer,
                userTestId: sessionStorage.getItem("userTestId"),
                testcode: paper?.data?.testcode || "",
                questionid: paper.questionOne[item].questionId
            }
            
            try {
                await fetch(`${url}/api/answer`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem("token")}`,
                    },
                    body: JSON.stringify(data),
                });
                
                setSelectedAnswers(prev => ({ ...prev, [item]: answer }));
                setStoredAnswers(prev => ({ ...prev, [paper.questionOne[item].questionId]: answer }));
            } catch (error) {
                console.error("Failed to save answer:", error);
            }
        }
    }

    const saveOrNext = async () => {
        if (answer === null) {
            // बिना आंसर दिए आगे बढ़ रहे हैं तो उसे छोड़कर जाते वक्त पीला कर दो
            if (item < paper.questionOne.length - 1) {
                setColorForLeavingQuestion(currentQuestionIndex);
                
                setIndex(String(item + 2).padStart(2, '0'));
                updateQuestion(item + 1);
                setCurrentQuestionIndex(item + 1);
                setColorForEnteringQuestion(item + 1);
            }
        } else {
            // सही आंसर दिया है, उसे हरा (Green) कर दो
            updateIndexColor(currentQuestionIndex, "#00A86B");
            await saveResult();
            
            if (item < paper.questionOne.length - 1) {
                setCurrentQuestionIndex(item + 1);
                setColorForEnteringQuestion(item + 1);
            }
        }
    }

    const marksForReview = async () => {
        updateIndexColor(currentQuestionIndex, "#800000");
        await saveResult();
        
        if (item < paper.questionOne.length - 1) {
            setCurrentQuestionIndex(item + 1);
            setColorForEnteringQuestion(item + 1);
        }
    }

    // FIX: बैकएंड से डेटा डिलीट करो, लेकिन क्वेश्चन स्क्रीन पर है इसलिए उसे ब्लू रहने दो
    const clearResponce = async () => {
        clear(); // यह UI से हटाकर कलर को ब्लू सेट कर देगा

        const data = {
            userTestId: sessionStorage.getItem("userTestId"),
            testcode: paper?.data?.testcode || "",
            questionid: paper.questionOne[item].questionId
        }

        try {
            await fetch(`${url}/api/deleteanswer`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify(data),
            });

            // स्टेट से हटा दें ताकि जब हम इसे छोड़ें, तो यह हरा (Green) न रहे
            setStoredAnswers(prev => {
                const newAnswers = { ...prev };
                delete newAnswers[paper.questionOne[item].questionId];
                return newAnswers;
            });
        } catch (error) {
            console.error("Clear Response Error:", error);
        }
    }

    const submit = async () => {
        if (timerInterval) clearInterval(timerInterval);

        const data = {
            exam: paper?.data?.examname || "",
            examid: paper?.data?.examid || "",
            paper: paper?.data?.papername || "",
            paperid: paper?.data?.paperid || "",
            type: type,
            testcode: paper?.data?.testcode || "",
            examCode: examCode,
            userTestId: sessionStorage.getItem("userTestId"),
            startdate: sessionStorage.getItem("date"),
            starttime: sessionStorage.getItem("time"),
            enddate: format(new Date(), 'DD MM YYYY'),
            endtime: format(new Date(), 'hh:mm:ss A'),
        }

        try {
            const Response = await fetch(url + "/api/submit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify(data),
            })
            const result = await Response.json()
            if (result.status === true) {
                alert("Your test is submitted successfully")
                navigate("/profile/result") 
            } else {
                alert(result.message || "Submission failed.")
            }
        } catch(error) {
            console.error("Submit Error:", error);
            alert("Network Error during submission.");
        }
    }

    const IndexKey = () => {
        if (!paper?.questionOne) return null;

        return paper.questionOne.map((question, index) => {
            const buttonColor = indexColors[index] || "black";
            return (
                <button
                    key={index}
                    onClick={() => indexClick(index)}
                    className="examIndexlistItem"
                    style={{
                        backgroundColor: buttonColor,
                        color: "white",
                        border: currentQuestionIndex === index ? "2px solid white" : "none"
                    }}
                >
                    {index + 1}
                </button>
            )
        })
    }

    return (
        <div className="examTopMainContainer" ref={elemRef}>
            {
                showinfobox &&
                <div className="examToggleMainContainer">
                    <div className="examToggleContainer">
                        <div className="examSubTitleMainContainer">
                            <div className="examSubTitleContainer">Time : </div>
                            <div className="examSubTitleData">{paper?.data?.duration || 0} hr</div>
                        </div>
                        <div className="examShowInfoToleContainer">
                            <button onClick={() => setShowinfobox(!showinfobox)} title="Hide Info">
                                <i className="fa-solid fa-angle-down"></i>
                            </button>
                        </div>
                        <div className="examSubTitleMainContainer">
                            <div className="examSubTitleContainer">Time Left :</div>
                            <div className="examSubTitleData">{formatTime(timeLeft)}</div>
                        </div>
                    </div>
                    <div className="examEndButtonContainer">
                        <button className="examEndButton" onClick={() => setTestClose(!testClose)}>
                            X
                        </button>
                    </div>
                </div>
            }

            {
                !showinfobox &&
                <div className="examMainInfoShowContainer">
                    <div className="examMenuInfoContainer">

                        <div className="examToggleContainer">
                            <div className="examSubTitleMainContainer">
                                <div className="examSubTitleContainer">Time : </div>
                                <div className="examSubTitleData">{paper?.data?.duration || 0} hr</div>
                            </div>
                            <div className="examShowInfoToleContainer" title="Show Info">
                                <button onClick={() => setShowinfobox(!showinfobox)}>
                                    <i className="fa-solid fa-angle-up"></i>
                                </button>
                            </div>
                            <div className="examSubTitleMainContainer">
                                <div className="examSubTitleContainer">Time Left :</div>
                                <div className="examSubTitleData">{formatTime(timeLeft)}</div>
                            </div>
                        </div>
                        <div className="examEndButtonContainer">
                            <button className="examEndButton" onClick={() => setTestClose(!testClose)}>
                                X
                            </button>
                        </div>
                    </div>

                    <div className="examMenuInfoContainer examMenuInfoContainerpadding">

                        <div className="examSubTitleMainContainer">
                            <div className="examSubTitleContainer">Questions : </div>
                            <div className="examSubTitleData">{paper?.data?.totalQuestions || 0}</div>
                        </div>

                        <div className="examSubTitleMainContainer">
                            <div className="examSubTitleContainer">Paper : </div>
                            {`${paper?.data?.examname || ""} / ${paper?.data?.papername || ""}`}
                        </div>

                        <div className="examSubTitleMainContainer">
                            <div className="examSubTitleContainer">Marks : </div>
                            <div className="examSubTitleData">{paper?.data?.totalMarks || 0}</div>
                        </div>

                    </div>

                    <div className="examMenuInfoContainer examMenuInfoContainerpadding">

                        <div className="examSubTitleMainContainer">
                            <div className="examSubTitleContainer">Type : </div>
                            <div className="examSubTitleData">{type}</div>
                        </div>
                        <div className="examSubTitleMainContainer">
                            <div className="examSubTitleContainer">Language : </div>
                            <div className="examSubTitleData">{langauge}</div>
                        </div>

                        {
                            year !== "undefined" ? <div className="examSubTitleMainContainer">
                                <div className="examSubTitleContainer">Year : </div>
                                <div className="examSubTitleData">{year}</div>
                            </div> : null
                        }

                        {
                            paper?.data?.seriescode || 0 !== undefined ? <div className="examSubTitleMainContainer">
                                <div className="examSubTitleContainer">Series Code : </div>
                                <div className="examSubTitleData">{`${paper?.data?.seriescode} / ${paper?.data?.seriesno}`}</div>
                            </div> : null
                        }

                        <div className="examSubTitleMainContainer">
                            <div className="examSubTitleContainer">Timer : </div>
                            <div className="examSubTitleData">{timer}</div>
                        </div>

                    </div>
                </div>
            }

            {/* Question Index Container */}
            <div className="examQuestionIndexContainer">
                Question No. : {index}
            </div>

            {
                splitlanguage.length === 2 ?
                    <>
                        <div className="eaxmLanguagechangeContainer">
                            <button onClick={languageChange}>
                                {changeLanguage}
                            </button>
                        </div>
                    </>
                    :
                    null
            }

            <div className="examshowIndexButtonContainar">
                <button onClick={() => setshowIndex(!showIndex)}>
                    Show Index
                    {
                        !showIndex ? <i className="fa-regular fa-eye"></i> : <i className="fa-solid fa-eye-slash"></i>
                    }
                </button>
            </div>

            {/* exam main content area */}
            <div className="examMainQuestionContainer">

                <div className="examAboutQestionAeraContainer">
                    <div className="examQuestionAnswerContainer">
                        <div className="examQuestionMainContainer">
                            <div className="examQuestionContainer">
                                <div dangerouslySetInnerHTML={{ __html: question }} />
                            </div>
                        </div>

                        <div className="examAnswerMainContainer">
                            <div className="examAnswerOptionMainContainer">

                                <div className="examAnswerOptionContainer">
                                    <div className="examOptionTitle">
                                        (A)
                                    </div>
                                    <div className="examOptionRadioButton">
                                        <input type="radio"
                                            name="Answer"
                                            value="a"
                                            checked={answer === "a"}
                                            onChange={() => setAnswer("a")}
                                        />
                                    </div>
                                    <div className="examShowAnswer">
                                        <div dangerouslySetInnerHTML={{ __html: optionOne }} />
                                    </div>
                                </div>

                                <div className="examAnswerOptionContainer">
                                    <div className="examOptionTitle">
                                        (B)
                                    </div>
                                    <div className="examOptionRadioButton">
                                        <input type="radio"
                                            name="Answer"
                                            value="b"
                                            checked={answer === "b"}
                                            onChange={() => setAnswer("b")} />
                                    </div>
                                    <div className="examShowAnswer">
                                        <div dangerouslySetInnerHTML={{ __html: optionTwo }} />
                                    </div>
                                </div>

                                <div className="examAnswerOptionContainer">
                                    <div className="examOptionTitle">
                                        (C)
                                    </div>
                                    <div className="examOptionRadioButton">
                                        <input type="radio"
                                            name="Answer"
                                            value="c"
                                            checked={answer === "c"}
                                            onChange={() => setAnswer("c")} />
                                    </div>
                                    <div className="examShowAnswer">
                                        <div dangerouslySetInnerHTML={{ __html: optionThree }} />
                                    </div>
                                </div>

                                <div className="examAnswerOptionContainer">
                                    <div className="examOptionTitle">
                                        (D)
                                    </div>
                                    <div className="examOptionRadioButton">
                                        <input type="radio"
                                            name="Answer"
                                            value="d"
                                            checked={answer === "d"}
                                            onChange={() => setAnswer("d")} />
                                    </div>
                                    <div className="examShowAnswer">
                                        <div dangerouslySetInnerHTML={{ __html: optionFour }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="examMultiButtonMainContainer">
                        <div className="examMultiButtonContainer">
                            <button className="examFnButton"
                                onClick={previous}
                            >Pre</button>
                            <button className="examFnButton"
                                onClick={saveOrNext}
                            >Save OR Next</button>
                            <button className="examFnButton"
                                onClick={marksForReview}
                            >Marks for Review</button>
                            <button className="examFnButton"
                                onClick={clearResponce}
                            >Clear Response</button>
                            <button className="examFnButton"
                                onClick={clear}
                            >Clear Answer</button>
                        </div>
                        <div className="examExamSubmitButton">
                            <button className="examFnButton"
                                onClick={() => setSubmitPopup(!submitPopup)}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>

                <div className={showIndex ? `examAboutIndexContainer show` : `examAboutIndexContainer hide`}>
                    <div className="examIndexMianContainer">
                        <div className="examIndexContainer">
                            {[
                                IndexKey()
                            ]}
                        </div>
                    </div>

                    <div className="examKeyIndiaterMainContainer">
                        <div className="examKeyIndiaterContainer">

                            <div className="examIndiaterColorContainer">
                                <div className="examIndiaterColorbox blue"></div>
                                <div className="examIndiaterColorCode">Current Question</div>
                            </div>

                            <div className="examIndiaterColorContainer">
                                <div className="examIndiaterColorbox black"></div>
                                <div className="examIndiaterColorCode">Unseen Question</div>
                            </div>

                            <div className="examIndiaterColorContainer ">
                                <div className="examIndiaterColorbox yellow"></div>
                                <div className="examIndiaterColorCode">Unanswered Question</div>
                            </div>

                            <div className="examIndiaterColorContainer">
                                <div className="examIndiaterColorbox green"></div>
                                <div className="examIndiaterColorCode">Answered Question</div>
                            </div>

                            <div className="examIndiaterColorContainer">
                                <div className="examIndiaterColorbox red"></div>
                                <div className="examIndiaterColorCode">Marked for Review</div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>

            {/* test start Info Container */}
            {
                startTest &&
                <>
                    <div className="examStartInfoBackground"></div>
                    <div className="examStartinfoMainContainer">
                        <div className="examPaperInfoMainTitleCotainer">
                            Paper Overview
                        </div>
                        <div className="examPeperMainInfoContainer">


                            <div className="examPeperInfoContainer">
                                <div className="examPeperTitle">Paper Name</div>
                                <div className="examPeperValue">
                                    {`${paper?.data?.examname ?? ""} / ${paper?.data?.papername ?? ""}`}
                                </div>
                            </div>

                            <div className="examPeperInfoContainer">
                                <div className="examPeperTitle">Type</div>
                                <div className="examPeperValue">{type}</div>
                            </div>

                            <div className="examPeperInfoContainer">
                                <div className="examPeperTitle">Language</div>
                                <div className="examPeperValue">{langauge}</div>
                            </div>

                            {
                                year !== "undefined" ? <div className="examPeperInfoContainer">
                                    <div className="examPeperTitle">Year : </div>
                                    <div className="examPeperValue">{year}</div>
                                </div> : null
                            }

                            {
                                paper?.data?.seriescode !== undefined ? <div className="examPeperInfoContainer">
                                    <div className="examPeperTitle">Series Code : </div>
                                    <div className="examPeperValue">{`${paper?.data?.seriescode} / ${paper?.data?.seriesno}`}</div>
                                </div> : null
                            }

                            <div className="examPeperInfoContainer">
                                <div className="examPeperTitle">Time</div>
                                <div className="examPeperValue">
                                    {paper?.data?.duration || ""} hr
                                </div>
                            </div>

                            <div className="examPeperInfoContainer">
                                <div className="examPeperTitle">Timer</div>
                                <div className="examPeperValue">{timer}</div>
                            </div>

                            <div className="examPeperInfoContainer">
                                <div className="examPeperTitle">Total Question</div>
                                <div className="examPeperValue">
                                    {paper?.data?.totalQuestions || 0}
                                </div>
                            </div>

                            <div className="examPeperInfoContainer">
                                <div className="examPeperTitle">Total Marks</div>
                                <div className="examPeperValue">
                                    {paper?.data?.totalMarks || 0}
                                </div>
                            </div>

                            <div className="examPeperInfoContainer">
                                <div className="examPeperTitle">Question Marks</div>
                                <div className="examPeperValue">
                                    {paper?.data?.itemMarks || 0}
                                </div>
                            </div>


                            <div className="examPeperInfoContainer">
                                <div className="examPeperTitle">Negative Marking</div>
                                <div className="examPeperValue">
                                    {
                                        paper?.data?.negativeMarks === 0 ? "No" : `Yes: (${paper?.data?.negativeMarks || 0})`
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="examStartMessageContainer">
                            Are you ready to start doing this test, If yes "click" on "start" button and your time is start,
                            and if No "click" on "back" button and end this test
                        </div>
                        <div className="examStartConfirambuttonContainer">
                            <div className="examStartConfirambutton">
                                <button style={{ backgroundColor: "#ef4444" }} onClick={BackToTest}>
                                    Back
                                </button>
                                <button style={{ backgroundColor: "#2563eb" }} onClick={testRun}>
                                    Start
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            }

            {
                submitPopup &&
                <>
                    <div className="examStartInfoBackground"></div>
                    <div className="examStartinfoMainContainer">
                        <div className="examStartMessageContainer">
                            If Your test is complite click on "submit" button,
                            if you want review your test click on "back to test" button
                        </div>
                        <div className="examStartConfirambuttonContainer">
                            <div className="examStartConfirambutton">
                                <button style={{ backgroundColor: "#64748b" }} onClick={() => setSubmitPopup(false)}>
                                    Back to test
                                </button>
                                <button style={{ backgroundColor: "#16a34a" }} onClick={submit}>
                                    submit
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            }

            {
                testClose && <>
                    <div className="examStartInfoBackground"></div>
                    <div className="examStartinfoMainContainer">
                        <div className="examStartMessageContainer">
                            All data from this test will be deleted and will not be evaluated if you close it. To confirm,
                            click "Close Test." To keep working on the test, click "Back to Test."
                        </div>
                        <div className="examStartConfirambuttonContainer">
                            <div className="examStartConfirambutton">
                                <button style={{ backgroundColor: "#ef4444" }} onClick={closeText}>
                                    Close Test
                                </button>
                                <button style={{ backgroundColor: "#2563eb" }} onClick={() => setTestClose(!testClose)}>
                                    Back to test
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}

export default Exam